import { ReactNode } from 'react';

import {
  DropDownFilter,
  FilterOption,
} from '@design-system/components/dropDown/dropDownFilter';
import { SearchInput } from '@design-system/components/searchinput';

import {
  ProgramsFilters as ProgramsFiltersState,
  ProgramsVM,
} from '../../view-model/programs.viewModel.types';

import * as styles from './ProgramsFilters.css';

type ProgramsFiltersProps = {
  state: Pick<ProgramsVM['state'], 'searchText' | 'filters'>;
  dispatch: ProgramsVM['dispatch'];
  actions?: ReactNode;
};

type StatusFilterValue = ProgramsFiltersState['status'];
type SoldAsFilterValue = ProgramsFiltersState['soldAs'];

const STATUS_OPTIONS: Array<FilterOption<StatusFilterValue>> = [
  { label: 'All', value: 'all' },
  { label: 'Draft', value: 'draft' },
  { label: 'Published', value: 'published' },
  { label: 'Archived', value: 'archived' },
];

const SOLD_AS_OPTIONS: Array<FilterOption<SoldAsFilterValue>> = [
  { label: 'All', value: 'all' },
  { label: 'Subscription', value: 'subscription' },
  { label: 'OTP', value: 'otp' },
  { label: 'None', value: 'none' },
];

// `'all'` → `undefined` so the trigger renders its label instead of a selected chip.
const toDropdownValue = <T extends string>(value: T | 'all'): T | undefined => {
  if (value === 'all') return undefined;
  return value;
};

export const ProgramsFilters = ({
  state,
  dispatch,
  actions,
}: ProgramsFiltersProps) => {
  return (
    <div className={styles.filtersContainer} data-testid="programs-filters">
      <div className={styles.searchInputContainer}>
        <SearchInput
          placeholder="Search by name"
          value={state.searchText}
          onChange={(event) => dispatch('Search', event.target.value)}
          onClear={() => dispatch('Search', '')}
        />
      </div>

      <DropDownFilter
        label="Status"
        options={STATUS_OPTIONS}
        value={toDropdownValue(state.filters.status)}
        onSelect={(value) => dispatch('SetFilter', { status: value ?? 'all' })}
      />

      <DropDownFilter
        label="Sold as"
        options={SOLD_AS_OPTIONS}
        value={toDropdownValue(state.filters.soldAs)}
        onSelect={(value) => dispatch('SetFilter', { soldAs: value ?? 'all' })}
      />

      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
};
